import dynamic from 'next/dynamic'

import { SwapProvider } from '@/components/home/context'
import useTrans from '@/hooks/useTrans'

import { Seo } from '@/components/base'
import { MainLayout } from '@/layouts/MainLayout'
import gssp from '@/utils/gssp'

const Home = dynamic(() => import('@/components/home'), { ssr: false })

const Index = () => {
  const trans = useTrans()

  return (
    <>
      <Seo
        data={{
          title: trans.meta.home.title,
          description: trans.meta.home.description,
          thumbnailUrl: trans.meta.home.thumb,
        }}
      />
      <MainLayout hasNautilus={true}>
        <SwapProvider>
          <Home />
        </SwapProvider>
      </MainLayout>
    </>
  )
}

export default Index

export const getServerSideProps = gssp()
